// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3QyGQ","rootSuccess":"CompleteLink_rootSuccess__2wYMe","rootFailure":"CompleteLink_rootFailure__3IXBh","isDisabled":"CompleteLink_isDisabled__x-i_C"};